import { useApp } from '@/context/AppContext'

// Province values matching the data (from Province column)
const PROVINCES = [
  'British Columbia',
  'Alberta',
  'Saskatchewan',
  'Manitoba',
  'Ontario',
  'Quebec',
  'New Brunswick',
  'Nova Scotia',
  'Prince Edward Island',
  'Newfoundland & Labrador',
  'Yukon',
  'NWT',
  'Nunavut',
]

export function ProvinceSelector() {
  const { state, setProvince } = useApp()
  const { filters } = state
  const selectedProvince = filters.selectedProvince
  const selectedBreak = filters.selectedBreak

  // Only show province filter when regiondetailed break is selected (to narrow down sub-regions)
  const showProvinceFilter = selectedBreak === 'regiondetailed'

  // Show arrow hint when regiondetailed is selected but no province filter
  const showArrowHint = selectedBreak === 'regiondetailed' && !selectedProvince

  // Don't render anything if province filter isn't relevant
  if (!showProvinceFilter) {
    return null
  }

  const handleProvinceChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value
    setProvince(value === '' ? undefined : value)
  }

  return (
    <div className="flex items-center gap-2" role="group" aria-label="Province filter">
      {/* Arrow hint when region break is selected */}
      {showArrowHint && (
        <span
          className="text-amber-600 dark:text-amber-400 text-xl font-bold animate-bounce"
          title="Select a province to narrow down regional results"
        >
          {'\u2192'}
        </span>
      )}
      <label
        htmlFor="province-select"
        className={`text-sm font-medium ${
          showArrowHint
            ? 'text-amber-700 dark:text-amber-300'
            : 'text-slate-600 dark:text-slate-300'
        }`}
      >
        Province:
      </label>
      <select
        id="province-select"
        value={selectedProvince || ''}
        onChange={handleProvinceChange}
        aria-label="Filter by province"
        className={`px-3 py-1.5 text-sm bg-white dark:bg-slate-700 border rounded-lg text-slate-700 dark:text-slate-200 focus:ring-2 focus:ring-primary-500 focus:border-primary-500 focus:outline-none ${
          showArrowHint
            ? 'border-amber-400 dark:border-amber-600 ring-2 ring-amber-200 dark:ring-amber-800'
            : 'border-slate-300 dark:border-slate-600'
        }`}
      >
        <option value="">All Provinces</option>
        {PROVINCES.map(province => (
          <option key={province} value={province}>
            {province}
          </option>
        ))}
      </select>
    </div>
  )
}
